<template>
  <b-sidebar
    id="add-new-user-sidebar"
    :visible="isAddNewUserSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @hidden="resetForm"
    @change="(val) => $emit('update:is-add-new-user-sidebar-active', val)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          Novo Perfil
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />
      </div>

      <!-- BODY -->
      <validation-observer
        #default="{ handleSubmit }"
        ref="refFormObserver"
      >
        <!-- Form -->
        <b-form
          class="p-2"
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
        >
          <validation-provider
            #default="validationContext"
            name="Nome"
            rules="required|alpha"
          >
            <b-form-group
              label="Nome"
              label-for="Nome"
            >
              <b-form-input
                id="name"
                v-model="perfilData.perfil_acesso_nome"
                autofocus
                :state="getValidationState(validationContext)"
                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

<!--          <validation-provider-->
<!--            #default="validationContext"-->
<!--            name="Permissao"-->
<!--            rules="required"-->
<!--          >-->
<!--            <b-form-group-->
<!--              label="Permissões"-->
<!--              label-for="user-role"-->
<!--              :state="getValidationState(validationContext)"-->
<!--            >-->
<!--              <v-select-->
<!--                  v-model="perfilData.permissao"-->
<!--                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"-->
<!--                  multiple-->
<!--                  label="action"-->
<!--                  :options="options"-->
<!--              />-->
<!--              <b-form-invalid-feedback :state="getValidationState(validationContext)">-->
<!--                {{ validationContext.errors[0] }}-->
<!--              </b-form-invalid-feedback>-->
<!--            </b-form-group>-->
<!--          </validation-provider>-->

          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
            >
              Salvar
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="hide"
            >
              Cancelar
            </b-button>
          </div>

        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton,
} from 'bootstrap-vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { ref } from '@vue/composition-api';
import { required, alphaNum, email } from '@core/utils/validations/validations';
import formValidation from '@core/comp-functions/forms/form-validation';
import Ripple from 'vue-ripple-directive';
import vSelect from 'vue-select';
import countries from '@/utils/countries';
import store from '@/store';

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    vSelect,

    // Form Validation
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isAddNewUserSidebarActive',
    event: 'update:is-add-new-user-sidebar-active',
  },
  props: {
    isAddNewUserSidebarActive: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      required,
      alphaNum,
      email,
      countries,
    };
  },
  setup(props, { emit }) {
    const blankPerfilData = {
      perfil_acesso_nome: '',
      created_by: null,
      updated_by: null,
    };

    const perfilData = ref(JSON.parse(JSON.stringify(blankPerfilData)));
    const resetuserData = () => {
      perfilData.value = JSON.parse(JSON.stringify(blankPerfilData));
    };

    const onSubmit = () => {
      console.log(perfilData.value);
      store.dispatch('app-perfilAcesso/addPerfilAcesso', perfilData.value)
        .then(() => {
          emit('refetch-data');
          emit('update:is-add-new-user-sidebar-active', false);
        });
    };

    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetuserData);

    return {
      perfilData,
      onSubmit,

      refFormObserver,
      getValidationState,
      resetForm,
    };
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select';

#add-new-user-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
